import React, { useMemo } from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

export default function AgreementBody({ markdown, className = '' }) {
  const html = useMemo(() => {
    if (!markdown) return '';
    const rendered = marked.parse(markdown, { gfm: true, breaks: false });
    return DOMPurify.sanitize(rendered);
  }, [markdown]);

  return (
    <div
      className={`prose prose-sm max-w-none dark:prose-invert ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
